import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { MyBoxContainer, MyFormControl, MyInputMiniLabel } from "../../../utils/theme";

interface ILogLevelProps {
  handleLogLevelChange: (event: SelectChangeEvent<number>) => void;
  logLevel: number;
}

export function LogLevel(logLevelProps: ILogLevelProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <MyBoxContainer display="flex" alignItems="center">
      <FormControl sx={{width: "7.3rem"}} variant="standard">
        <MyInputMiniLabel data-cy="log-level-label" htmlFor="logLevel-select" >
          {t("logLevel")}
        </MyInputMiniLabel>
        <Select
          onChange={logLevelProps.handleLogLevelChange}
          name="logLevel"
          value={logLevelProps.logLevel}
          variant="standard"
          required
          inputProps={{
            name: "logLevel",
            id: "logLevel-select"
          }}>
          <MenuItem value={"0"}>DEBUG</MenuItem>
          <MenuItem value={"1"} selected>
            INFO
          </MenuItem>
          <MenuItem value={"2"}>WARNING</MenuItem>
          <MenuItem value={"3"}>ERROR</MenuItem>
        </Select>
      </FormControl>
    </MyBoxContainer>
  );
}
